// Route path constants
export const ROUTES = {
  HOME: '/',
  BILLING: '/PayBill',
  PLAN: '/PlanUsage',
  NETWORK: '/Network',
  PROFILE: '/Profile',
  STREAM: '/Stream',
  UPDATE_BILL_CYCLE: '/UpdateBillCycle',
  INVOICE: '/Invoice',
  SCHEDULE_INSTALLATION: '/ScheduleInstallation',
  SHOP_ADDONS: '/ShopAddons',
  DISCONNECT: '/Disconnect',
  HELP: '/Help',
  SIGN_CONTRACT: '/SignContract',
  NETWORK_MANAGEMENT: '/Network/Management',
  NETWORK_WIFI: '/Network/Wifi',
  NETWORK_BRIDGE: '/Network/Bridge',
} as const;

// Route labels for navigation
export const ROUTE_LABELS = {
  [ROUTES.HOME]: 'Overview',
  [ROUTES.SIGN_CONTRACT]: 'SignContract',
  [ROUTES.BILLING]: 'PayBill',
  [ROUTES.PLAN]: 'PlanUsage',
  [ROUTES.NETWORK]: 'Network',
  [ROUTES.PROFILE]: 'Profile',
  [ROUTES.STREAM]: 'Stream',
  [ROUTES.UPDATE_BILL_CYCLE]: 'Update Bill Cycle',
  [ROUTES.INVOICE]: 'Invoice',
  [ROUTES.SCHEDULE_INSTALLATION]: 'Schedule Installation',
  [ROUTES.SHOP_ADDONS]: 'Shop Add-ons',
  [ROUTES.DISCONNECT]: 'Disconnect',
  [ROUTES.HELP]: 'Help',
  [ROUTES.NETWORK_MANAGEMENT]: 'Network Management',
  [ROUTES.NETWORK_WIFI]: 'WiFi Mode',
  [ROUTES.NETWORK_BRIDGE]: 'Bridge Mode',
} as const;

export enum NetworkLink {
  Reboot = 'Reboot',
  Network = 'Network',
  DiagnosticResults = 'DiagnosticResults',
  Wifi = 'Wifi',
  Bridge = 'Bridge',
}

export enum ShopAddonsLink {
  ShopAddons = 'ShopAddons',
  SingleAddon = 'SingleAddon',
  GroupedAddon = 'GroupedAddon',
}

export enum PayBillLink {
  PayBill = 'PayBill',
  UpdateBillCycle = 'UpdateBillCycle',
  OneTimePayment = 'OneTimePayment',
  AutoPay = 'AutoPay',
  Invoice = 'Invoice',
  SelectBillCycle = 'SelectBillCycle',
  ManageBilling = 'ManageBilling',
}

export enum PlanLink {
  Plan = 'PlanUsage',
  ChoosePlanFilter = 'ChoosePlanFilter',
}

export enum StackLink {
  Profile = 'Profile',
  Stream = 'Stream',
  ScheduleInstallation = 'ScheduleInstallation',
  Disconnect = 'Disconnect',
  Overview = 'Overview',
}

export enum TabLink {
  Billing = 'Billing',
}

export enum WebHome {
  OrderSummary = 'OrderSummary',
  Stream = 'Stream',
}

export enum WebRoutes {
  Error = 'Error',
  Home = 'Home',
  Main = '',
}
